module.exports = __webpack_public_path__ + "img/fossil2Img4.c017e32f.jpg";